import React from "react";
import { useState } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import {
  Box,
  Button,
  InputLabel,
  ListItem,
  Stack,
  TextField,
  Typography,
  Tooltip as MUITooltip,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAllUnit } from "../../store/njesiRaportuese";
import { setLoading } from "../../store/loading";
import SelectFilter from "../UI/SelectFilter";
import ButtonAdd from "../UI/ButtonAdd";
import ContainerAnalyst from "../UI/ContainerAnalyst";
import { useNavigate, useLocation } from "react-router-dom";
import { checkErrorYear } from "../../utils/validationData";
import { CHARTS_TEMPLATE, SwitchCustomChart } from "./SwitchCustomChart";
import useFormsFormulaStore from "../../store/zustandStore/formsFormulaZs";
import BarChartIcon from "@mui/icons-material/BarChart";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export function Graph() {
  const { formTemplate } = useSelector((state) => state.formTemplate);
  const { graphById } = useSelector((state) => state.graphDashboard);
  const user = useSelector((state) => state.auth.user);

  const {
    fetchFormsFormulaZs,
    formsFormulaZs,
    getEvaluateFormFormulaZs,
    evaluateFormFormulaZs,
    getDataForTableChartZs,
    dataForTableChartZs,
    dataForTableChartPostProcessZs,
  } = useFormsFormulaStore();

  const currentYear = new Date().getFullYear();

  const navigate = useNavigate();
  const location = useLocation();

  const dispatch = useDispatch();

  const [state, setState] = React.useState({
    reportingUnitId: "",
    formId: "",
    //start
    formulaId: "",
    year: currentYear - 1,
    chartTemplateId: null,
    formFormulaType: "SIMPLE",
    formFormula: null,
  });
  const [apiWithPostProcessing, setApiWithPostProcessing] =
    React.useState(false);

  const searchStateUnit = React.useRef("");
  const searchStateForm = React.useRef("");
  const searchStateChartTemplate = React.useRef("");

  const [searchValueServerUnit, setSearchValueServerUnit] = React.useState("");
  const [searchValueServerForm, setSearchValueServerForm] = React.useState("");
  const [anchorElForm, setAnchorElForm] = React.useState(null);
  const [anchorElChartTemplate, setAnchorElChartTemplate] =
    React.useState(null);

  const handleClickForm = (event) => {
    setApiWithPostProcessing(false);
    setAnchorElForm(event.currentTarget);
  };
  const handleClickChartTemplate = (event) => {
    setAnchorElChartTemplate(event.currentTarget);
  };

  const handleCloseForm = () => {
    setAnchorElForm(null);
  };
  const handleCloseChartTempalte = () => {
    setAnchorElChartTemplate(null);
  };

  const openForm = Boolean(anchorElForm);
  const openChartTemplate = Boolean(anchorElChartTemplate);

  const searchItemsForm = (e) => {
    const searchValue = e.target.value;
    if (
      searchValue !== "" &&
      searchValue !== null &&
      searchValue !== undefined &&
      searchStateForm !== null &&
      searchStateForm?.current !== null &&
      searchStateForm?.current?.valueOf !== null
    ) {
      searchStateForm.current.valueOf = searchValue;
      let filterTimeout;
      filterTimeout = setTimeout(() => {
        setSearchValueServerForm(searchStateForm?.current?.valueOf ?? "");
      }, 1000);
    } else {
      setSearchValueServerForm("");
      // dispatch(getAllUnit({ page: 0, searchValue: "" }));
    }
  };

  React.useEffect(() => {
    fetchFormsFormulaZs();
  }, []);

  React.useEffect(() => {
    getAllDataUnit();
  }, [dispatch, searchValueServerUnit]);

  const listIndicatorUpdate = [];
  for (var r = 0; r < graphById?.inputs?.length; r++) {
    listIndicatorUpdate.push({
      id: graphById?.inputs[r].formInput,
      label: graphById?.inputs[r].label,
    });
  }

  const getAllDataUnit = () => {
    dispatch(setLoading(true));
    dispatch(
      getAllUnit({
        page: 0,
        searchValue: searchValueServerUnit,
        size: 1000,
        filterSelect: true,
      })
    )
      .unwrap()
      .then(() => {
        dispatch(setLoading(false));
      })
      .catch(() => {
        dispatch(setLoading(false));
      });
  };

  const sendRequestIndikator = () => {
    if (state?.formFormulaType === "API") {
      getDataForTableChartZs(
        "API",
        state?.formFormula?.payload?.apiFormFormula?.apiEndpoint,
        state?.postProcessing
      );
      if (
        state?.formFormulaType === "API" &&
        state?.postProcessing !== "string" &&
        state?.postProcessing !== ""
      ) {
        setApiWithPostProcessing(true);
      }
    } else {
      const selected = (({ formulaId, year }) => ({ formulaId, year }))(state);
      getEvaluateFormFormulaZs(selected);
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setState({ ...state, [name]: value ? value : "" });
  };

  const openGraphTable = () => {
    navigate("/graphic/table");
  };

  return (
    <ContainerAnalyst
      header={
        <Box sx={{ width: "100%" }}>
          <Stack direction="row" sx={{ mb: 2, width: "100%" }} spacing={1}>
            <Stack direction="row" sx={{ mb: 1, width: "100%" }}>
              <Typography
                variant="h5"
                sx={{
                  pr: "12px",
                  justifyContent: "center",
                  fontFamily: "Basier Circle",
                  fontSize: "20px",
                  color: "#091B3D",
                  alignContent: "center",
                }}
              >
                Chart Template:
              </Typography>

              <Stack>
                <Stack spacing={2} sx={{ mr: "10px" }}>
                  <SelectFilter
                    textfield
                    maxWidth={"400px"}
                    // disabledfilter={!state.reportingUnitId}
                    name="chartTemplateId"
                    id="chartTemplateId"
                    label="Template Chart"
                    placeholder="Template Chart"
                    noOptionsText="Nuk ka Template Chart"
                    value={state.chartTemplateId}
                    onClick={handleClickChartTemplate}
                    source={CHARTS_TEMPLATE}
                    open={openChartTemplate}
                    anchorEl={anchorElChartTemplate}
                    onClickAway={handleCloseChartTempalte}
                    onClose={(event, reason) => {
                      if (reason === "escape") {
                        handleCloseForm();
                      }
                    }}
                    onChange={(event, newValue, reason) => {
                      if (
                        event.type === "keydown" &&
                        event.key === "Backspace" &&
                        reason === "removeOption"
                      ) {
                        return;
                      }
                      setState({
                        ...state,
                        chartTemplateId: newValue?.id ? newValue?.id : "",
                      });
                      handleCloseChartTempalte();
                    }}
                    // onchangesearch={searchItemsForm}
                    inputRef={searchStateForm}
                  ></SelectFilter>
                </Stack>
              </Stack>
            </Stack>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                width: "100%",
                alignItems: "center",
              }}
            >
              {/* {!isEditor && !isInputer && (
                <IconButton
                  sx={{
                    backgroundColor: "#B2D4FF",
                    ":hover": { backgroundColor: "#B2D4FF" },
                    marginRight: "5px",
                    color: "white",
                  }}
                  type="button"
                  onClick={handleOpenSearchModal}
                >
                  <Search></Search>
                </IconButton>
              )} */}
              <ButtonAdd
                labelbutton={
                  !checkErrorYear(state?.year) &&
                  state.formulaId !== "" &&
                  "Gjenero"
                }
                style={{}}
                disabled={checkErrorYear(state?.year) || state.formulaId === ""}
                onClick={sendRequestIndikator}
              ></ButtonAdd>
              <Button
                sx={{
                  height: "48px",
                  backgroundColor: "#CD3728",
                  color: "#fff",
                  borderRadius: "8px",
                  // width: "100%",
                  "&.MuiButtonBase-root:hover": {
                    backgroundColor: "#ff3824",
                  },
                  marginLeft: "5px",
                }}
                onClick={openGraphTable}
              >
                Grafikët Ekzistues
              </Button>
            </Box>
          </Stack>
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              alignContent: "flex-start",
              mb: "20px",
            }}
          >
            <Stack spacing={2} sx={{ mr: "10px" }}>
              <InputLabel required>Thirrja e të dhënave</InputLabel>
              <SelectFilter
                textfield
                maxWidth={"500px"}
                // disabledfilter={!state.reportingUnitId}
                name="formulaId"
                id="formulaId"
                label="Thirrja e të dhënave"
                placeholder="Kërko Thirrje te dhenash"
                noOptionsText="Nuk ka Thirrje te dhenash"
                value={state.formulaId}
                onClick={handleClickForm}
                source={formsFormulaZs}
                open={openForm}
                anchorEl={anchorElForm}
                onClickAway={handleCloseForm}
                onClose={(event, reason) => {
                  if (reason === "escape") {
                    handleCloseForm();
                  }
                }}
                onChange={(event, newValue, reason) => {
                  if (
                    event.type === "keydown" &&
                    event.key === "Backspace" &&
                    reason === "removeOption"
                  ) {
                    return;
                  }
                  setState({
                    ...state,
                    formId: newValue?.id ? newValue?.id : "",
                    formulaId: newValue?.id ? newValue?.id : "",
                    formFormulaType: newValue?.type ?? "SIMPLE",
                    formFormula: newValue ?? null,
                    name: newValue?.name ?? "",
                    postProcessing: newValue?.postProcessing ?? null,
                  });
                  // getAllDataFormIndikator();
                  handleCloseForm();
                }}
                onchangesearch={searchItemsForm}
                inputRef={searchStateForm}
              ></SelectFilter>
            </Stack>

            <Stack spacing={2} sx={{ mr: "10px" }}>
              <InputLabel required>Viti</InputLabel>
              <TextField
                name="year"
                disabled={!state?.formulaId}
                autoComplete="off"
                id="year"
                number
                variant="outlined"
                error={checkErrorYear(state?.year)}
                helperText={
                  checkErrorYear(state?.year) ? "Viti nuk është i saktë" : null
                }
                sx={{
                  "&.MuiTextField-root .MuiInputBase-root.MuiOutlinedInput-root":
                    { height: "50px", backgroundColor: "#f6f8fc" },
                }}
                value={state.year}
                onChange={handleInputChange}
              />
            </Stack>
          </Box>
        </Box>
      }
    >
      <Box></Box>
      <div
        style={{
          backgroundColor: "white",
          textAlign: "-webkit-center",
          padding: "0px 20px 20px 20px",
        }}
      >
        <div style={{ width: "700px" }}>
          {state?.chartTemplateId === "" &&
          state?.formulaId === "" &&
          state?.chartTemplateId === undefined &&
          state?.formulaId === undefined ? (
            <Stack
              sx={{
                marginTop: "100px",
                textAlign: "center",
                alignItems: "center",
              }}
            >
              <BarChartIcon
                sx={{ fontSize: "70px", color: "rgb(151 154 156)" }}
              ></BarChartIcon>
              <br />
              <Typography sx={{ color: "rgb(151 154 156)" }}>
                {"Nuk ka asnjë Grafik"}
              </Typography>
            </Stack>
          ) : (
            <SwitchCustomChart
              dataChart={
                apiWithPostProcessing
                  ? dataForTableChartPostProcessZs
                  : evaluateFormFormulaZs ?? []
              }
              chartTemplateId={state?.chartTemplateId}
              formFormulaId={state.formulaId}
              year={state.year}
              name={state.name}
            />
          )}
        </div>
      </div>
    </ContainerAnalyst>
  );
}
